import { c as e } from "../../../../index.esm-BeDSGXP5.js";
import { css as n } from "styled-components";
const r = (o) => o.componentColors.header, a = {
  base: ({ theme: o }) => /* @__PURE__ */ n([
    "width:100%;box-sizing:border-box;",
    ""
  ], e({
    backgroundColor: [
      r(o).background.mobile,
      null,
      r(o).background.desktop
    ],
    borderBottom: [
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      `3px solid ${r(o).border.mobile}`,
      null,
      "none"
    ],
    paddingX: [
      "sm",
      "lg"
    ]
  })),
  container: ({ bordered: o, theme: l, maxWidth: t = "eightColumn" }) => /* @__PURE__ */ n([
    "display:flex;align-items:center;",
    ""
  ], e({
    boxSizing: "border-box",
    width: "100%",
    minHeight: [
      "6rem",
      null,
      "11rem"
    ],
    maxWidth: t,
    margin: "0 auto",
    borderBottom: [
      "none",
      null,
      o ? `2px solid ${// eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      r(l).border.desktop}` : "none"
    ]
  })),
  contentWrapper: () => /* @__PURE__ */ n([
    "",
    ""
  ], e({
    display: "flex",
    alignItems: "center",
    width: "100%",
    height: "auto",
    flexWrap: [
      "wrap",
      null,
      "nowrap"
    ]
  }))
};
export {
  a as default
};
